import { TablePagination } from 'ui/molecules';
import { Row } from 'ui/organisms';
import { SelectChangeEvent } from '@mui/material';

interface Props<T> {
  minWidth?: number | string;
  rows: Row<T>[];
  rowsPerPage: number;
  page: number;
  defaultRowCount: number;
  handlePageChange: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void;
  handleRowsPerPageChange: (value: number) => void;
}

export const TableFooter = <T,>(props: Props<T>) => {
  return (
    <TablePagination
      minWidth={props.minWidth}
      rowsPerPage={props.rowsPerPage}
      page={props.page}
      defaultRowCount={props.defaultRowCount}
      rowsCount={props.rows.length}
      handlePageChange={props.handlePageChange}
      handleRowsPerPageChange={props.handleRowsPerPageChange}
    />
  );
};
